export default __webpack_public_path__ + "static/media/Stalker's Deathmask of Creeping Death.203d4f99.jpg";